import React from 'react';

import { GenericError } from 'pages';


const NotFound = () => {
  return (
    <GenericError
      code="404"
      headline={
        <span>
          What you're seeking,<br/>
          it's not here.
        </span>
      }
    />
  );
};


export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/_system/NotFound.js